<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Project Committee</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form>
        <v-row>
          <v-col cols="12">
            <CommitteeMembersList :members="members" @deleteMember="deleteMember($event)"></CommitteeMembersList>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import CommitteeMembersList from "../child/CommitteeMembersList";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert, CommitteeMembersList },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    addData: {
      position: null,
      member: null
    },
    members: [],

  }),

  mounted() {
    this.getCommitteeMemberList();
  },

  methods: {
    getCommitteeMemberList() {
      if (this.uuid !== null) {
        ProjectService.getCommitteeMemberList(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.members = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.members = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
  },
};
</script>
